import { PRODUCTS_CATALOG_URL, SERVICES_CATALOG_URL } from '../config'
import { SocialLinks } from '../features/home/SocialLinks'

const CATALOGS = [
  { label: 'Produse', href: PRODUCTS_CATALOG_URL },
  { label: 'Servicii', href: SERVICES_CATALOG_URL },
]

/* Every vertical gap is tied to the viewport height, so the whole page fits one laptop screen
   without a scrollbar and still breathes on a tall monitor. On a phone the content is taller
   than the screen and the page simply scrolls. */
const GAP = 'mt-[clamp(1rem,4.5vh,3rem)]'

export function HomePage() {
  return (
    <main className="flex min-h-full flex-col items-center px-6 py-[clamp(1.5rem,5vh,4rem)] text-center">
      <div className="flex w-full flex-1 flex-col items-center justify-center">
        {/* The logo art is a circle inside a square with white corners, so clipping it to a
            circle is what lets it sit on the sage background without a white box around it. */}
        <img
          src="/icons/icon-512x512.png"
          alt="Seva Naturii"
          width={512}
          height={512}
          className="size-[clamp(7rem,min(22vh,40vw),13rem)] rounded-full shadow-2xl shadow-(--color-forest)/30"
        />

        <h1
          className={`${GAP} max-w-3xl font-(family-name:--font-display) text-[length:var(--text-display)] leading-[1.2] font-semibold tracking-wide text-balance text-(--color-brand)`}
        >
          Mai mult decât îngrijirea pielii.
          <br />O reconectare cu corpul&nbsp;tău.
        </h1>

        <p className="mt-[clamp(0.75rem,2.5vh,1.5rem)] max-w-md text-base leading-relaxed tracking-wide text-pretty text-(--color-forest)/80 sm:text-lg">
          Leacuri naturale create manual în loturi mici și ritualuri de relaxare profundă pentru
          trup și minte.
        </p>

        {/* Plain links to the files, opened in a new tab: every browser and both phone
            platforms already have a PDF reader with page navigation, and none of them can be
            beaten by an embedded one. Not routes — there is no catalog page to get wrong. */}
        <nav aria-label="Cataloage" className={`${GAP} flex w-full max-w-72 flex-col gap-4`}>
          {CATALOGS.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-(--color-forest) py-[clamp(0.9rem,2.4vh,1.25rem)] font-(family-name:--font-display) text-xl font-medium tracking-wider text-(--color-cream) shadow-lg shadow-(--color-forest)/25 transition hover:-translate-y-0.5 hover:bg-(--color-brand) hover:shadow-xl focus-visible:ring-4 focus-visible:ring-(--color-forest)/30 focus-visible:outline-none sm:text-2xl"
            >
              {label}
            </a>
          ))}
        </nav>
      </div>

      <footer className={`${GAP} flex flex-col items-center gap-3`}>
        <SocialLinks />
        <p className="text-sm tracking-wide text-(--color-forest)/60">Iași &middot; Vișan</p>
      </footer>
    </main>
  )
}
